import Icon from '../../components/Icon.vue'

Icon.register({"brands/medium":{"width":448,"height":512,"paths":[{"d":"M0 32V480H448V32H0zM372.2 138.1L348.2 161.1C346.1 162.7 345.1 165.3 345.5 167.8V337.1C345.1 339.7 346.1 342.3 348.2 343.8L371.7 366.8V371.9H253.7V367L278 343.4C280.4 341 280.4 340.3 280.4 336.7V199.8L212.8 371.4H203.7L125 199.8V314.8C124.3 319.6 126 324.5 129.4 328L161 366.3V371.4H71.2V366.3L102.8 328C106.2 324.5 107.7 319.6 106.9 314.8V181.8C107.3 178.1 105.9 174.5 103.1 172L75 138.1V133H162.3L229.7 281 289 133.1H372.2V138.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/medium.js
// module id = He+p
// module chunks = 0